import React, { createContext, useContext, useEffect, useState } from "react"
import { readUserContext, normalizePermissionGroup } from "./sessionService"

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [authorization, setAuthorization] = useState({
        roles: [],
        permissions: [],
        isLoaded: false
    });

    useEffect(() => {
        let isMounted = true;
        function safeLoadAuthorization() {
            if (!isMounted) {
                return;
            }
            loadAuthorization();
        }
        safeLoadAuthorization();
        return () => {
            isMounted = false;
        };
    }, []);

    function loadAuthorization() {
        /*const userContext = sessionStorage.getItem("userContext");*/
        const userContext = readUserContext();

        if (!userContext) {
            setAuthorization({
                roles: [],
                permissions: [],
                isLoaded: true
            });
            return;
        }

        try {
            //const uc = JSON.parse(userContext);
            const uc = userContext;
            //const userProfile = uc?.userProfile;
            setAuthorization({
                roles: uc.userRole
                    ? [uc.userRole]
                    : [],
                permissions: Array.isArray(uc.permissions)
                    ? uc.permissions
                    : [],
                isLoaded: true
            })
        } catch(error) {
            setAuthorization({
                roles: [],
                permissions: [],
                isLoaded: true
            });
        }
    }

    function refreshAuthorization() {
        loadAuthorization();
    }

    function clearAuthorization() {
        setAuthorization({
            roles: [],
            permissions: [],
            isLoaded: true
        });
    }

    function hasPermission(permission) {
        return typeof permission === "string" &&
            authorization.permissions.includes(permission.trim());
    }

    function hasAnyPermission(permissions) {
        const normalizedPermissions =
            normalizePermissionGroup(permissions);

        return normalizedPermissions.some(permission =>
            authorization.permissions.includes(permission)
        );
    }

    function hasAllPermissions(permissions) {
        const normalizedPermissions =
            normalizePermissionGroup(permissions);

        return normalizedPermissions.length > 0 &&
            normalizedPermissions.every(permission =>
                authorization.permissions.includes(permission)
            );
    }

    return (
        <AuthContext.Provider
            value={{
                authorization,
                refreshAuthorization,
                clearAuthorization,
                hasPermission,
                hasAnyPermission,
                hasAllPermissions
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}